import React, { useRef, useState } from 'react';
import { Menu, X, Phone, MapPin, Globe } from 'lucide-react';
// Add at the top of your component file
import { createClient } from '@supabase/supabase-js';

import logo from '../../assets/2.png'
import hero from '../../assets/hero.png'


import qrlink from '../../assets/qrcode.png'

const supabase = createClient(
  'https://nchmnskurdxtnptengqy.supabase.co',
  'sb_publishable_BMGtPewIPiUvekGpvd_YBQ_0ZLwVjC1'
);

const translations = {
  kk: {
    nav: {
      about: 'Конференция туралы',
      sections: 'Бөлімдер',
      register: 'Тіркелу'
    },
    hero: {
      title: 'Халықаралық ғылыми-практикалық конференция',
      subtitle: 'Сіздерді Қазақстан Республикасы Президенті Іс басқармасының Медициналық қызметінің 95 жылдығына арналған Халықаралық ғылыми-практикалық конференцияға қатысуға шақырамыз. Конференция білім мен тәжірибе алмасу үшін жетекші мамандарды біріктіреді.',
      date: '11 қараша, 2025',
      location: 'Астана, Қазақстан',
      cta: 'Тіркелу'
    },
    about: {
      title: 'Қазақстан Республикасының зертханалық қызметін жетілдіру',
      description_date_bold: 'Күні: ',
      description_date: '11.11.2025',
      description_loc_bold: 'Өткізілу орны: ',
      description_loc: 'Астана қ., Сызғанов к-сі, 3/2, Қазақстан Республикасы Президенті Іс басқармасының Медициналық орталығының Санитарлық-эпидемиологиялық сараптама орталығы.'
    },
    sections: {
      title: 'Конференция бөлімдері',
      cardiology: {
        title: 'Кардиология',
        desc: 'Жүрек-қан тамырлары аурулары, диагностика және емдеу әдістері'
      },
      neurology: {
        title: 'Неврология',
        desc: 'Жүйке жүйесі аурулары, инновациялық терапия және зерттеулер'
      },
      oncology: {
        title: 'Онкология',
        desc: 'Қатерлі ісіктер, алдын алу және қазіргі заманғы емдеу тәсілдері'
      },
      pediatrics: {
        title: 'Педиатрия',
        desc: 'Балалар денсаулығы, даму және жас ерекшеліктері'
      },
      surgery: {
        title: 'Хирургия',
        desc: 'Қазіргі заманғы хирургиялық техникалар және минималды инвазивті әдістер'
      },
      therapeutics: {
        title: 'Терапия',
        desc: 'Жалпы медицина, созылмалы аурулар және емдеу стратегиялары'
      }
    },
    form: {
      title: 'Конференцияға тіркелу',
      subtitle: 'Халықаралық ғылыми-тәжірибелік конференцияға қатысу үшін төмендегі форманы толтырыңыз.',
      fullName: 'ТАӘ',
      email: 'E-mail',
      phone: 'Телефон нөмірі',
      position: 'Лауазымы мен жұмыс орны',
      section: 'Қызығушылық танытқан секция',
      selectSection: 'Бөлімді таңдаңыз',
      format: 'Қатысу форматы',
      online: 'Онлайн',
      offline: 'Офлайн',
      consent: 'Деректерді өңдеуге келісім',
      submit: 'Тіркелу',
      disclaimer: 'Сіздің деректеріңіз іс-шараны ұйымдастыру мақсатында ғана пайдаланылады және үшінші тұлғаларға берілмейді.',
      success: 'Тіркелу сәтті өтті! Сізге email арқылы растау хаты жіберіледі.'
    },
    footer: {
      contact: 'Байланыс',
      address: 'Астана қ., Сызғанов к-сі, 3/2',
      follow: 'Бізді қадағалаңыз',
      rights: '© 2025 Халықаралық медицина конференциясы. Барлық құқықтар қорғалған.'
    }
  },
  ru: {
    nav: {
      about: 'О конференции',
      sections: 'Секции',
      register: 'Регистрация'
    },
    hero: {
      title: 'Проверка квалификации (МЛС) от надежного провайдера: рядом и доступно',
      subtitle: 'Конференция станет площадкой для обсуждения актуальных вопросов обеспечения качества лабораторных исследований, обмена опытом и знакомства с современнными решениями в области проверки квалификации.',
      date: '5 августа, 2026',
      location: 'Астана, Казахстан',
      cta: 'Регистрация'
    },
    about: {
      title: 'Совершенствование лабораторной службы Республики Казахстан',
      description_date_bold: 'Дата: ',
      description_date: '05.08.2026',
      description_loc_bold: 'Место проведения: ',
      description_loc: 'г. Астана, ул. Сызганова, 3/2, Центр санитарно-эпидемиологической экспертизы Медицинского центра Управления делами Президента Республики Казахстан.'
    },
    sections: {
      title: 'Секции конференции',
      cardiology: {
        title: 'Кардиология',
        desc: 'Сердечно-сосудистые заболевания, диагностика и методы лечения'
      },
      neurology: {
        title: 'Неврология',
        desc: 'Заболевания нервной системы, инновационная терапия и исследования'
      },
      oncology: {
        title: 'Онкология',
        desc: 'Злокачественные опухоли, профилактика и современные методы лечения'
      },
      pediatrics: {
        title: 'Педиатрия',
        desc: 'Детское здоровье, развитие и возрастные особенности'
      },
      surgery: {
        title: 'Хирургия',
        desc: 'Современные хирургические техники и минимально инвазивные методы'
      },
      therapeutics: {
        title: 'Терапия',
        desc: 'Общая медицина, хронические заболевания и стратегии лечения'
      }
    },
    form: {
      title: 'Регистрация на конференцию',
      subtitle: 'Заполните форму, чтобы принять участие в конференции.',
      fullName: 'ФИО',
      email: 'E-mail',
      phone: 'Номер телефона',
      position: 'Должность и место работы',
      section: 'Секция конференции',
      selectSection: 'Выберите секцию',
      format: 'Формат участия',
      online: 'Онлайн',
      offline: 'Офлайн',
      consent: 'Согласие на обработку персональных данных',
      disclaimer: 'Ваши данные будут использованы исключительно для организации мероприятия и не будут переданы третьим лицам.',
      submit: 'Регистрация',
      success: 'Регистрация прошла успешно! Вам будет отправлено письмо с подтверждением.'
    },
    footer: {
      contact: 'Контакты',
      address: 'г. Астана, ул. Сызганова, 3/2',
      follow: 'Следите за нами',
      rights: '© 2025 РГП "ЦСЭЭ" УДП РК. Все права защищены.'
    }
  }
};

const countryCodes = [
  { code: '+7', country: 'KZ', format: '(###) ###-##-##' },
  { code: '+7', country: 'RU', format: '(###) ###-##-##' },
  { code: '+1', country: 'US', format: '(###) ###-####' },
  { code: '+44', country: 'UK', format: '(####) ######' },
  { code: '+49', country: 'DE', format: '(###) ########' },
  { code: '+33', country: 'FR', format: '(#) ## ## ## ##' },
  { code: '+86', country: 'CN', format: '### #### ####' },
  { code: '+81', country: 'JP', format: '##-####-####' },
  { code: '+82', country: 'KR', format: '##-####-####' },
  { code: '+91', country: 'IN', format: '##### #####' }
];

function Home() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(''); 
  const [lang, setLang] = useState<keyof typeof translations>('ru');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    countryCode: '+7',
    position: '',
    format: 'offline',
    consent: false
  });
  const [showSuccess, setShowSuccess] = useState(false);
//  const [emailVerifying, setEmailVerifying] = useState(false);

  const t = translations[lang];

  const toggleVideoMute = () => {
    const nextMutedState = !isMuted;
    setIsMuted(nextMutedState);

    if (videoRef.current) {
      videoRef.current.muted = nextMutedState;
    }
  };

//   const verifyEmail = async (email: string): Promise<boolean> => {
//   setEmailVerifying(true);
//   try {
//     const { data, error } = await supabase.functions.invoke('verify-email', {
//       body: { email }
//     });

//     if (error || !data?.valid) {
//       return false;
//     }
//     return true;
//   } catch (err) {
//     console.error('Email verification error:', err);
//     return false;
//   } finally {
//     setEmailVerifying(false);
//   }
  // };
  

  const formatPhoneNumber= (value: string, format: string): string => {
    const numbers: string = value.replace(/\D/g, '');
    if (!numbers) return '';

    const formatWithoutCode = format.replace(/^\+\d+\s?/, '');
    let result = '';
    let numIndex = 0;
    
    for (let i = 0; i < formatWithoutCode.length && numIndex < numbers.length; i++) {
      if (formatWithoutCode[i] === '#') {
        result += numbers[numIndex];
        numIndex++;
      } else {
        result += formatWithoutCode[i];
      }
    }

    return result;
  };

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    const numbers = input.replace(/\D/g, '');
    setFormData({ ...formData, phone: numbers });
  };

const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
  e.preventDefault();
  if (!formData.consent) {
    alert(lang === 'kk' ? 'Деректерді өңдеуге келісіміңізді беріңіз' : 'Пожалуйста, дайте согласие на обработку данных');
    return;
  }

  setIsSubmitting(true);
  setError('');

  try {
    // Verify email
    // const emailIsValid = await verifyEmail(formData.email);

    // if (!emailIsValid) {
    //   setError(lang === 'kk'
    //     ? 'Email мекенжайы жарамсыз немесе жоқ'
    //     : 'Email адрес недействителен или не существует'
    //   );
    //   setIsSubmitting(false);
    //   return;
    // }

    // Format phone number with country code
    const formattedPhone = formData.countryCode + ' ' + displayPhone;

    // Prepare data for Supabase
    const registrationData = {
      full_name: formData.fullName,
      email: formData.email,
      phone: formattedPhone,
      position: formData.position,
      format: formData.format,
      language: lang
    };

    // Insert into Supabase
    const { data, error: supabaseError } = await supabase
      .from('registrations')
      .insert([registrationData])
      .select();

    if (supabaseError) {
      throw supabaseError;
    }

    console.log('Registration saved:', data);

    // Send confirmation email via Edge Function
    if (data && data[0]) {
      const { error: emailError } = await supabase.functions.invoke('send-confirmation-email', {
        body: { registration_id: data[0].id }
      });

      // console.log('registration_id:', data[0].id);

      if (emailError) {
        console.error('Email send error:', emailError);
        // Don't fail the whole registration if email fails
      } else {
        console.log('Confirmation email sent successfully');
      }
    }

    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 5000);

    // Reset form
    setFormData({
      fullName: '',
      email: '',
      phone: '',
      countryCode: '+7',
      position: '',
      format: 'offline',
      consent: false
    });

  } catch (err) {
    console.error('Error saving registration:', err);
    setError(lang === 'kk'
      ? 'Тіркеу кезінде қате орын алды. Қайталап көріңіз.'
      : 'Произошла ошибка при регистрации. Попробуйте еще раз.');
  } finally {
    setIsSubmitting(false);
  }
};

  const selectedCountry = countryCodes.find(c => c.code === formData.countryCode) || countryCodes[0];
  const displayPhone = formData.phone ? formatPhoneNumber(formData.phone, selectedCountry.format) : '';

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50">
      {/* Header */}
      <header className="bg-white shadow-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center min-h-max">
            <div className="flex items-center">
              <img src={logo} alt="logo" className='max-h-24 hidden sm:block space-x-2'/>
              {/* <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">MC</span>
              </div>
              <span className="ml-3 text-xl font-semibold text-gray-900 hidden sm:block">MedConf 2025</span> */}
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex space-x-8">
              <a href="#about" className="text-gray-700 hover:text-blue-600 transition">{t.nav.about}</a>
              <a href="#register" className="text-gray-700 hover:text-blue-600 transition">{t.nav.register}</a>
            </nav>

            <div className="flex items-center space-x-4">
              <div className="flex bg-gray-100 rounded-lg p-1">
                <button
                  onClick={() => setLang('kk')}
                  className={`px-3 py-1 rounded transition ${lang === 'kk' ? 'bg-white shadow-sm' : 'text-gray-600'}`}
                >
                  ҚҚ
                </button>
                <button
                  onClick={() => setLang('ru')}
                  className={`px-3 py-1 rounded transition ${lang === 'ru' ? 'bg-white shadow-sm' : 'text-gray-600'}`}
                >
                  РУ
                </button>
              </div>

              <button
                className="md:hidden"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              >
                {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="md:hidden py-4 border-t">
              <nav className="flex flex-col space-y-4">
                <img src={logo} alt="logo" className='max-h-20 max-w-fit {`${}`}'/>
                <a href="#about" className="text-gray-700 hover:text-blue-600" onClick={() => setMobileMenuOpen(false)}>{t.nav.about}</a>
                <a href="#register" className="text-gray-700 hover:text-blue-600" onClick={() => setMobileMenuOpen(false)}>{t.nav.register}</a>
              </nav>
            </div>
          )}
        </div>
      </header>

      {/* Hero Section */}
      <section
        className="relative text-white py-20 px-4 min-h-screen flex items-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.15), rgba(0,0,0,0.85)), url(${hero})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6">{t.hero.title}</h1>
          <p className="text-xl sm:text-2xl mb-4 text-blue-100">{t.hero.subtitle}</p>
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mb-8 text-lg">
            <span className="flex items-center">
              <Globe className="mr-2" size={20} />
              {t.hero.date}
            </span>
            <span className="hidden sm:inline">•</span>
            <span className="flex items-center">
              <MapPin className="mr-2" size={20} />
              {t.hero.location}
            </span>
            
          </div>
          
          <a
            href="#register"
            className="inline-block bg-white text-blue-600 font-semibold px-8 py-3 rounded-lg hover:bg-blue-50 transition shadow-lg"
          >
            {t.hero.cta}
          </a>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-16 px-4 bg-slate-50 flex flex-col">
        <div className="max-w-4xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">{t.about.title}</h2>
          <div className="flex gap-2">
            <p className="text-lg text-gray-700 leading-relaxed font-bold">{t.about.description_date_bold}</p>
            <p className="text-lg text-gray-700 leading-relaxed">{t.about.description_date}</p>
          </div>
          <div className="flex gap-2 mb-6">
            <p className="text-lg text-gray-700 leading-relaxed w-4/6"><strong>{t.about.description_loc_bold}</strong>{t.about.description_loc}</p>
          </div>
          <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
            <div className="text-base text-slate-700 leading-relaxed">
              ЦСЭЭ приглашает вас на запланированную конференцию: Zoom.
              <br /><br />
              Конференция: "Проверка квалификации (МЛС) от надежного провайдера: рядом и доступно" <br />
              Время: 5 авг. 2026 09:00 AM Астана, Алматы <br />
              Присоединиться к конференции Zoom <br />
              <a
                href="https://us06web.zoom.us/j/86074532893?pwd=bbMz6OTAU1jNUsn7YzWMAbsw5APDPi.1"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 underline break-all"
              >
                https://us06web.zoom.us/j/86074532893?pwd=bbMz6OTAU1jNUsn7YzWMAbsw5APDPi.1
              </a>
              <br /><br />

              Ссылка на чат конференции<br />
              <a
                href="https://us06web.zoom.us/launch/jc/86074532893"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 underline break-all"
              >
                https://us06web.zoom.us/launch/jc/86074532893
              </a>
              <br /><br />

              Идентификатор конференции: 860 7453 2893 <br />
              Код доступа: 034624
            </div>
          </div>
        </div>
        <div className="max-w-screen">
          {/* Slider */}
          {/* <div className="flex flex-wrap gap-4 justify-center items-stretch">
            {[img1, img2, img3].map((src, i) => (
              <div key={i} className="w-full sm:w-1/2 md:w-1/3 lg:w-1/4">
                <img
                  src={src}
                  alt={`Slide ${i + 1}`}
                  className="w-full h-40 sm:h-48 md:h-56 object-cover rounded-lg shadow-sm"
                />
              </div>
            ))}
          </div> */}
          {/* End Slider */}
          <div className="mx-auto max-w-4xl rounded-2xl overflow-hidden shadow-lg bg-black relative">
            <video
              ref={videoRef}
              src="/vidos.mp4"
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-auto object-cover"
            />
            <button
              type="button"
              onClick={toggleVideoMute}
              className="absolute bottom-3 right-3 rounded-full bg-black/70 text-white px-3 py-2 text-sm font-medium backdrop-blur-sm hover:bg-black/90 transition"
            >
              {isMuted ? 'Unmute' : 'Mute'}
            </button>
          </div>
        </div>
        <div className="max-w-4xl mx-auto flex flex-row items-center mt-12 gap-6">
          <img src={qrlink} alt="download" className='max-w-32'/>
          <a
            href="/proga.pdf"
            download="Сводная программа международной конференции.pdf"
            className="text-blue-600 hover:text-blue-800 underline transition"
            target="_blank"
            rel="noopener noreferrer"
          >
            Сводная программа конференции
          </a>
          <a
            href="/presentations.zip"
            download="Презентации участников.zip"
            className="text-blue-600 hover:text-blue-800 underline transition"
            target="_blank"
            rel="noopener noreferrer"
          >
            Презентации участников скачать
          </a>
        </div>
      </section>

      {/* Registration Form */}
      <section id="register" className="py-16 px-4">
        <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-xl p-6 sm:p-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">{t.form.title}</h2>
          <p className="text-center text-gray-600 mb-6">{t.form.subtitle}</p>
          
          {showSuccess && (
            <div className="mb-6 p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg">
              {t.form.success}
            </div>
          )}
         {error && (
            <div className="mb-6 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <input
                type="text"
                required
                placeholder={`${t.form.fullName}`}
                value={formData.fullName}
                onChange={(e) => setFormData({ ...formData, fullName: e.target.value })}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>

            <div>
              <input
                type="email"
                required
                placeholder={t.form.email}
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>

            <div className='w-full'>
              <div className="flex gap-2">
                <select
                  value={formData.countryCode}
                  onChange={(e) => setFormData({ ...formData, countryCode: e.target.value, phone: '' })}
                  className="w-24 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  {countryCodes.map((c) => (
                    <option key={c.country} value={c.code}>
                      {c.country} {c.code}
                    </option>
                  ))}
                </select>
                <input
                  type="tel"
                  required
                  value={displayPhone}
                  onChange={handlePhoneChange}
                  placeholder={selectedCountry.format}
                  className="w-full flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
            </div>

            <div>
              <input
                type="text"
                required
                placeholder={t.form.position}
                value={formData.position}
                onChange={(e) => setFormData({ ...formData, position: e.target.value })}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-3">{t.form.format}</label>
              <div className="flex gap-4">
                <label className="flex items-center cursor-pointer">
                  <input
                    type="radio"
                    name="format"
                    value="online"
                    checked={formData.format === 'online'}
                    onChange={(e) => setFormData({ ...formData, format: e.target.value })}
                    className="w-4 h-4 text-blue-600 focus:ring-blue-500"
                  />
                  <span className="ml-2">{t.form.online}</span>
                </label>
                <label className="flex items-center cursor-pointer">
                  <input
                    type="radio"
                    name="format"
                    value="offline"
                    checked={formData.format === 'offline'}
                    onChange={(e) => setFormData({ ...formData, format: e.target.value })}
                    className="w-4 h-4 text-blue-600 focus:ring-blue-500"
                  />
                  <span className="ml-2">{t.form.offline}</span>
                </label>
              </div>
            </div>

            <div>
              <label className="flex items-start cursor-pointer">
                <input
                  type="checkbox"
                  checked={formData.consent}
                  onChange={(e) => setFormData({ ...formData, consent: e.target.checked })}
                  className="w-4 h-4 mt-1 text-blue-600 focus:ring-blue-500 rounded"
                />
                <span className="ml-2 text-sm text-gray-700">{t.form.consent}</span>
              </label>
            </div>

            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold py-3 rounded-lg hover:from-blue-700 hover:to-indigo-700 transition shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isSubmitting ? (lang === 'kk' ? 'Тіркелуде...' : 'Регистрация...') : t.form.submit}
            </button>
          </form>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
            <div>
              <h3 className="text-xl font-semibold mb-4">{t.footer.contact}</h3>
              <div className="space-y-3">
                <p className="flex items-center">
                  <MapPin size={18} className="mr-2 flex-shrink-0" />
                  {t.footer.address}
                </p>
                <p className="flex items-center">
                  <Phone size={18} className="mr-2 flex-shrink-0" />
                  +7‒701-494-56-64 | Нусупбаева Гаухар
                </p>
              </div>
              <div className="flex gap-4 mt-6">
                <a href="https://www.instagram.com/cseemc.kz/" className="w-10 h-10 bg-pink-600 rounded-lg flex items-center justify-center hover:bg-pink-700 transition">
                  <span className="font-bold">i</span>
                </a>
                <a href="https://moseso.qr-pib.kz/ru/" className="w-10 h-10 bg-blue-400 rounded-lg flex items-center justify-center hover:bg-blue-500 transition">
                  <span className="font-bold">w</span>
                </a>
              </div>
            </div>
          </div>

          <div className="mb-8">
            <div className="w-full h-64 bg-gray-800 rounded-lg overflow-hidden">
              <iframe
                src="https://yandex.com/map-widget/v1/?ll=71.430411,51.128422&z=15&l=map&pt=71.430411,51.128422,pm2rdm"
                width="100%"
                height="100%"
                frameBorder="0"
                allowFullScreen
                className="rounded-lg"
                title='map'
              />
            </div>
          </div>

          {/* <div className="border-t border-gray-700 pt-6 text-center text-gray-400">
            <p>{t.footer.rights}</p>
          </div> */}
        </div>
      </footer>
    </div>
  );
}

export default Home;
